// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/799
import type { PAPEventGeneric } from "../base/event";
import type { FileType } from "../enums/file_type";
import type { PreviewType } from "../enums/preview_type";
import type { StartType } from "../enums/start_type";
import type { PreviewFailureReason } from "../enums/preview_failure_reason";
import type { FileCategory } from "../enums/file_category";

// Event_name: 'preview.file'
// Description: Start: Marked when a user has expressed intent to preview a file.
// Success: A user is able to render the preview page with a successful preview.
// Failed: The preview page did not render and will never render without corrective or manual action.
// Canceled: A user navigated away or scrolled past the preview surface for a file
// Detailed description here: https://www.dropbox.com/scl/fi/k4odgwuxxkfpgx80xdc8u/Previews-Reliability.paper?dl=0&rlkey=7jj7ety6sqf69nl5a5f1sndr0
// Owner: previews
export type Preview_File = PAPEventGeneric<
  'previews',
  'preview',
  'file',
  {
    // The screen the user will go into in order to perform the specific action. i.e. files tab, app extension.
    actionScreen?: string;
    // a file type of a file
    fileType?: FileType;
    // The type of shared preview screen that was shown for this shared content
    previewType?: PreviewType;
    // Size in bytes of the file
    fileSize?: number;
    // what is the error message the user received
    errorMessage?: string;
    // General use field for recording the error code
    errorCode?: number;
    // Marker to determine whether this load is the result of:
    // - initial: first request of action that was user action initiated
    // - retry: retry after failure from initial request (can be user or system initiated)
    // - update: update after notification
    startType?: StartType;
    // Elapsed time in milliseconds since the start event fired. Only for terminal states of: success, failed, cancel.
    timeSinceStartMs?: number;
    // The file_obj_id, revision or cypress OID being viewed.
    // Note: Mobile will NOT be logging file paths. We should log opaque identifiers when we have them (e.g. after loading metadata) but unfortunately it will have to be optional.
    contentIdentifier?: string;
    // Client generated UUID for connecting file action Hive events.
    actionId?: string;
    // The category of error preventing this preview from loading.
    // network error: (rejection) We can’t connect to the previews backend
    // unimplemented: (rejection) The content in question is not supported by Previews
    // permission_denied: (rejection) We have lost permission (or never had permission) to view this file
    // not_found: (rejection) The file in question has been deleted or we can no longer find it
    // resource_exhausted: (true failure) We are experiencing rate limiting or other resource contention
    // rend
    previewFailureReason?: PreviewFailureReason;
    // The module the user will select from the Action Screen in order to perform the action. i.e. quick_actions_empty_state, quick_actions_header
    // **NOTE: you must update the allowlist if you're using this for a new value: https://dropbox.atlassian.net/wiki/spaces/PAP/pages/1093468269/Action+Element+Sanitization
    actionElement?: string;
    // When preview (or other applicable action/view event) happens from a user swiping left or right on a file or tapping left or right arrows to view another file.
    isFileToFile?: boolean;
    // Experiment variant that the user was exposed to
    experimentVariant?: string;
    // [Special Field] The "file_extension" is a string of a file's extension which is sanitized within the pipeline. Events with this field are enriched with a corresponding file category property (Document, Image, Video)
    fileExtension?: string;
    // Trace id to validate that PAP and legacy events are logging consistently
    validationTraceId?: string;
    // This is an ID for a specific comment provided by the Comments2 API.
    commentId?: string;
    // [Special Field] The "file_category" is a set of values indicating the category of a file. This property can either be provided manually or will be automatically added during enrichment if there is a "file_extension" property on the event. See https://sourcegraph.pp.dropbox.com/server/-/blob/dropbox/file_extension/category_constants.py for mapping to file extensions
    fileCategory?: FileCategory;
    // describes how a file was uploaded
    uploadMethod?: string;
  }
>;

export function PAP_Preview_File(properties?: Preview_File['properties']): Preview_File {
  return <Preview_File>{
    class: 'previews',
    action: 'preview',
    object: 'file',
    properties,
  };
}
